
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";


export const TextFieldEncryptedComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleChange = (event: any) => {
    const value = event.target.value;

    onChange(value, layoutField);
  }


  return (
      <TextField
         fullWidth
         error={false}
         disabled={layoutField.AccessSetting_sys === 'read'}
         required={layoutField.ReferencedField_sys.Required_sys}
         size="small"
         label={`${layoutField.ReferencedField_sys.Label_sys} (max. ${layoutField.ReferencedField_sys.Length_sys})`}
         variant="filled"
         type={showPassword ? "text" : "password"}
         value={value}
         onChange={(event) => handleChange(event)}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         inputProps={{
           maxLength: layoutField.ReferencedField_sys.Length_sys,
         }}
         InputProps={{
           disableUnderline: true,
           endAdornment: (
              <InputAdornment position="end">
                 <IconButton size="small" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                </IconButton>
            </InputAdornment>
        ),
      }}
      />
    );

};
